// extracted by mini-css-extract-plugin
export default {"wrapper":"SlideImage_wrapper__1REoE","image":"SlideImage_image__1v1MJ"};